import React from "react";
import Images from "../../../assets/images/index";

export default function NoDataFound(){
    return(
        <div className="no_data_found_wrapper text-center mt-4">
            <img src={Images.NoData} alt="No Data" className="img-fluid"/>
            <div className="no_data_text">
                <h4>No Data Found</h4>
                <p>We don't have any data regarding your request.</p>
            </div>
        </div>
    )
}